import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Megaphone } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NotePopupGate = () => {
  const [queue, setQueue] = useState([]);
  const [left, setLeft] = useState(0);
  const [sending, setSending] = useState(false);
  const current = queue[0];

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/my-popup-notes`);
      setQueue((q) => (q.length ? q : data || []));
    } catch (e) {
      console.error('Error fetching popup notes:', e);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 10 * 60 * 1000);
    return () => clearInterval(id);
  }, [load]);

  useEffect(() => {
    if (!current) return undefined;
    setLeft(Math.max(0, current.popup_seconds || 0));
    const id = setInterval(() => setLeft((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, [current]);

  const ack = async () => {
    setSending(true);
    try {
      await axios.post(`${API_URL}/my-popup-notes/${current.id}/ack`);
      setQueue((q) => q.slice(1));
    } catch (e) {
      toast.error("Impossible d'enregistrer la lecture, réessayez");
    } finally {
      setSending(false);
    }
  };

  if (!current) return null;
  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      style={{ pointerEvents: 'auto' }}
      onPointerDown={(e) => e.stopPropagation()}
      data-testid="note-popup-overlay"
    >
      <div className="w-full max-w-lg rounded-2xl bg-card text-card-foreground border shadow-2xl p-6 space-y-4" data-testid="note-popup">
        <div className="flex items-center gap-3">
          <span className="h-10 w-10 rounded-full bg-blue-100 dark:bg-blue-900/40 flex items-center justify-center">
            <Megaphone className="h-5 w-5 text-blue-600 dark:text-blue-300" />
          </span>
          <div>
            <h2 className="text-lg font-bold">Message important</h2>
            <p className="text-xs text-muted-foreground">
              De {current.created_by} · {new Date(current.created_at).toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
        <p className="text-sm whitespace-pre-wrap leading-relaxed max-h-[50vh] overflow-y-auto" data-testid="note-popup-content">
          {current.content}
        </p>
        <Button className="w-full" disabled={left > 0 || sending} onClick={ack} data-testid="note-popup-ack-btn">
          {left > 0 ? `Veuillez lire le message (${left} s)` : "J'ai pris connaissance du message"}
        </Button>
        {queue.length > 1 && (
          <p className="text-xs text-center text-muted-foreground">{queue.length - 1} autre(s) message(s) à suivre</p>
        )}
      </div>
    </div>
  );
};

export default NotePopupGate;
